import {
  COLLAGE_LAYOUTS_OPTIONS,
  DEFAULT_SHOW_MORE_HEIGHT,
} from '../../constants/proGalleryConstants';
import { getCurrentSettings } from './gallerySettings';
import { getGalleryInfo } from './galleryHeight';

const getItemsOnSection = (
  loadItemsOnSection,
  countRowNeedToDisplay,
  numRows,
  countMedias,
) => {
  let itemsOnSection = loadItemsOnSection * (countRowNeedToDisplay / numRows);
  // NO DELETE:
  // in case we display 3 images in section somtimes we display 6
  //  and this if calculate this
  if (loadItemsOnSection === COLLAGE_LAYOUTS_OPTIONS.LARGE.loadItemsOnSection) {
    itemsOnSection =
      itemsOnSection + loadItemsOnSection * Math.trunc(itemsOnSection / 9);
  }

  const isDispalyAllMedias = itemsOnSection >= countMedias;

  return { itemsOnSection, isDispalyAllMedias };
};

const getIsDispalyShowMoreBtn = (isShowMoreBtn, isDispalyAllMedias) => {
  return isShowMoreBtn && !isDispalyAllMedias;
};

const getItemInfo = (padding, numberOfImagesPerRow, imageMargin) => {
  const widthGallery = window.innerWidth - padding;
  const itemWidth =
    (widthGallery - (numberOfImagesPerRow - 1) * imageMargin) /
    numberOfImagesPerRow;
  const itemHeight = itemWidth;
  const rowHeight = itemHeight + imageMargin;
  return { itemWidth, itemHeight, rowHeight };
};

const fixRowsIfAllMediasLoaded = (
  countMedias,
  loadItemsOnSection,
  numRows,
  rowHeight,
) => {
  // Fix rows and remove "Load More" btn
  let countSectionsNeedToDisplay = Math.ceil(countMedias / loadItemsOnSection);
  if (loadItemsOnSection === COLLAGE_LAYOUTS_OPTIONS.LARGE.loadItemsOnSection) {
    countSectionsNeedToDisplay =
      countSectionsNeedToDisplay -
      Math.trunc(countSectionsNeedToDisplay / 3) +
      1;
  }
  const countRowNeedToAddNow = countSectionsNeedToDisplay * numRows;
  return rowHeight * countRowNeedToAddNow;
};

/**
 * Update proGallery height with collage layout
 * @param {Number} widgetHeight - height of all widget without this gallery.
 * @param {String} type - type of gallery ( HASHTAG / FEED ).
 */
export const updateCollageHeight1 = (widgetHeight, type) => (dispatch) => {
  const {
    numberOfImagesPerRow,
    numRows,
    imageMargin,
    galleryMargin,
    isShowMoreBtn,
    loadItemsOnSection,
    countBlocksDisplay,
  } = getCurrentSettings(type);
  const {
    typeActionMoreData,
    countRowDisplay,
    isLoadedMore,
    items,
  } = getGalleryInfo(type);

  const countRowNeedToDisplay = isLoadedMore
    ? countRowDisplay
    : numRows * countBlocksDisplay;
  const padding = 2 * galleryMargin || 0;
  const { rowHeight } = getItemInfo(padding, numberOfImagesPerRow, imageMargin);
  let sectionHeight = rowHeight * countRowNeedToDisplay;

  const { isDispalyAllMedias } = getItemsOnSection(
    loadItemsOnSection,
    countRowNeedToDisplay,
    numRows,
    items.length,
  );
  if (isDispalyAllMedias) {
    // Fix rows and remove "Load More" btn
    sectionHeight = fixRowsIfAllMediasLoaded(
      items.length,
      loadItemsOnSection,
      numRows,
      rowHeight,
    );
  }

  let newHeight =
    sectionHeight - imageMargin + padding + DEFAULT_SHOW_MORE_HEIGHT;

  const isDispalyShowMoreBtn = getIsDispalyShowMoreBtn(
    isShowMoreBtn,
    isDispalyAllMedias,
  );
  if (isDispalyShowMoreBtn && imageMargin < 22) {
    newHeight = newHeight - 20;
  }

  const heightShowMoreNeedToRemove = isDispalyShowMoreBtn
    ? 0
    : DEFAULT_SHOW_MORE_HEIGHT;

  window.Wix.setHeight(Math.max(0, widgetHeight + newHeight - heightShowMoreNeedToRemove));

  dispatch({
    type: typeActionMoreData,
    payload: {
      rowHeight,
      isDispalyShowMoreBtn,
      heightShowMoreNeedToRemove,
      sectionHeight,
      height: newHeight,
      padding,
    },
  });
};

/**
 * Collage - Update proGallery height when load more medias
 */
export const loadMoreCollageUpdateHeight1 = (type) => (dispatch) => {
  const {
    numRows,
    loadItemsOnSection,
    countBlocksDisplay,
  } = getCurrentSettings(type);
  let {
    height,
    items,
    typeActionMoreData,
    countRowDisplay,
    isDispalyShowMoreBtn,
    sectionHeight,
    rowHeight,
  } = getGalleryInfo(type);

  const countRowDisplayInSection = numRows * countBlocksDisplay;
  const countRowNeedToDisplay =
    countRowDisplay === 0
      ? countRowDisplayInSection * 2
      : countRowDisplay + countRowDisplayInSection;
  sectionHeight = rowHeight * countRowNeedToDisplay;

  const { isDispalyAllMedias } = getItemsOnSection(
    loadItemsOnSection,
    countRowNeedToDisplay,
    numRows,
    items.length,
  );

  // If count of media is smaller then (row * columns) that user selected
  if (isDispalyAllMedias) {
    // Fix rows and remove "Load More" btn
    sectionHeight = fixRowsIfAllMediasLoaded(
      items.length,
      loadItemsOnSection,
      numRows,
      rowHeight,
    );
  }

  isDispalyShowMoreBtn = getIsDispalyShowMoreBtn(
    isDispalyShowMoreBtn,
    isDispalyAllMedias,
  );

  height = sectionHeight;
  window.Wix.setHeight(Math.max(0, window.innerHeight + sectionHeight));

  dispatch({
    type: typeActionMoreData,
    payload: {
      countRowDisplay: countRowNeedToDisplay,
      isDispalyShowMoreBtn,
      height,
      isLoadedMore: true,
    },
  });
};
